import $ from 'jquery';

$(document).ready(function () {
  acfImageGalleryBlock();
});

function acfImageGalleryBlock() {
  $('.js-acf-image-gallery-block').each(function () {});
}
